import { type CollectionModelBase, CollectionModelFieldHeight, type FormModel } from '@ikegps/core-shared';
import { type FieldJoin, FieldJoinMatch } from './field.join/field.join';
import { IkeCalcWireAttachmentHeightFieldJoin } from './field.join/field.join.ikecalc.wire';
import { PoleForemanPowerCircuitPhaseHeightFieldJoin } from './field.join/field.join.poleforeman.powercircuit';
import { PoleForemanWirePhaseHeightFieldJoin } from './field.join/field.join.poleforeman.wire';
import type { IkeClientService } from './index';

export class MeasurementService implements IkeClientService {
	__priority = 100;

	isFormSupported(form: FormModel): boolean {
		if (form == null) {
			return false;
		}

		if (form.metadata == null || form.metadata.import == null) {
			return false;
		}

		const type = form.metadata.import.type;
		return type === 'ikecalc' || type === 'spidacalc' || type === 'poleforeman';
	}

	getFieldJoins(collection: CollectionModelBase): FieldJoinMatch[] {
		const fieldJoins: FieldJoin[] = [];

		collection.forEachField((field) => {
			if (!CollectionModelFieldHeight.isHeightField(field)) {
				return;
			}

			if (IkeCalcWireAttachmentHeightFieldJoin.accepts(field)) {
				const fieldJoin = new IkeCalcWireAttachmentHeightFieldJoin(field);
				fieldJoins.push(fieldJoin);
			} else if (PoleForemanWirePhaseHeightFieldJoin.accepts(field)) {
				const fieldJoin = new PoleForemanWirePhaseHeightFieldJoin(field);
				fieldJoins.push(fieldJoin);
			} else if (PoleForemanPowerCircuitPhaseHeightFieldJoin.accepts(field)) {
				const fieldJoin = new PoleForemanPowerCircuitPhaseHeightFieldJoin(field);
				fieldJoins.push(fieldJoin);
			}
		});

		const matches: FieldJoinMatch[] = [];

		for (let i = 0; i < fieldJoins.length; i++) {
			const joiningField = fieldJoins[i];
			for (let j = i + 1; j < fieldJoins.length; j++) {
				const candidateJoiningField = fieldJoins[j];

				if (
					joiningField.type === candidateJoiningField.type &&
					joiningField.field.schema.id === candidateJoiningField.field.schema.id &&
					joiningField.joins(candidateJoiningField)
				) {
					const match = new FieldJoinMatch(joiningField, candidateJoiningField);
					matches.push(match);

					break;
				}
			}
		}

		return matches;
	}
}
